import { Props } from "react-apexcharts"

export const lineChartOptions: Props = {
  colors: ['#0166FF', '#5D4DEB', '#E20101', '#FEC551', '#48E1C6'],
  responsive: [
    {
      breakpoint: 3000,
      options: {
        chart: {
          width: 1000,
          height: 300
        }
      }
    },
    {
      breakpoint: 2000,
      options: {
        chart: {
          width: 1000,
          height: 300
        }
      }
    },
    {
      breakpoint: 1769,
      options: {
        chart: {
          width: 900,
          height: 200
        }
      }
    },
    {
      breakpoint: 1601,
      options: {
        chart: {
          width: 900,
          height: 270
        }
      }
    },
    {
      breakpoint: 1376,
      options: {
        chart: {
          width: 700,
          height: 170
        }
      }
    },
    {
      breakpoint: 1270,
      options: {
        chart: {
          width: 600,
          height: 170
        }
      }
    },
    {
      breakpoint: 1166,
      options: {
        chart: {
          width: 500,
          height: 240
        }
      }
    },
    {
      breakpoint: 1025,
      options: {
        chart: {
          width: 750,
          height: 270
        }
      }
    },

    {
      breakpoint: 860,
      options: {
        chart: {
          width: 670,
          height: 270
        }
      }
    },

    {
      breakpoint: 731,
      options: {
        chart: {
          width: 550,
          height: 270
        }
      }
    },

    {
      breakpoint: 530,
      options: {
        chart: {
          width: 450,
          height: 270
        }
      }
    },
    {
      breakpoint: 450,
      options: {
        chart: {
          width: 350,
          height: 270
        }
      }
    }
  ],
  chart: {
    width: 900,
    type: 'area',
    zoom: {
      type: 'x',
      enabled: true,
      autoScaleYaxis: true
    },
    toolbar: {
      autoSelected: 'zoom'
    }
  },
  dataLabels: {
    enabled: false
  },
  markers: {
    size: 0
  },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      inverseColors: false,
      opacityFrom: 0.5,
      opacityTo: 0,
      stops: [0, 90, 100]
    }
  },

  yaxis: {
    labels: {
      formatter: function (val: any) {
        return val.toFixed(0)
      }
    }
  },
  xaxis: {
    type: 'datetime',
    labels: {
      format: 'dd/MM'
    }
  },
  tooltip: {
    shared: false,
    y: {
      formatter: function (val: number) {
        return val.toFixed(0)
      }
    }
  },
  legend: {
    show: false
  }
}



export const metrics = ['total_exams', 'logo_share', 'exam_view_quantity', 'baby_users_quantity', 'booking_clicks']
